import { Component } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from '../../../environments/environment';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-doctors-list',
  templateUrl: './doctors-list.component.html',
  styleUrls: ['./doctors-list.component.scss']
})
export class DoctorsListComponent {
  doctors:any;
  specialityId:any;
  isLoading: boolean = false;
 branchId :any;
  params: any;
  isHospitalApp: any;
  hospitalId: any;
  currentPage: number = 1;
  itemsPerPage: number = 6; // Number of doctors per page
  paginatedDoctors: any[] = [];
  totalPages: number = 9;



  length = 0;
  pageSize = 6;
  pageIndex = 0;
  pageSizeOptions = [5, 10, 25];

  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;

  pageEvent: PageEvent | any;


  // handlePageEvent(e: PageEvent) {
  //   this.pageEvent = e;
  //   this.length = e.length;
  //   this.pageSize = e.pageSize;
  //   this.pageIndex = e.pageIndex;
  //   this.updatePagination();
  // }




  // updatePagination() {
  //   this.totalPages = Math.ceil(this.doctors.length / this.itemsPerPage);
  //   const startIndex = (this.currentPage - 1) * this.itemsPerPage;
  //   const endIndex = startIndex + this.itemsPerPage;
  //   this.paginatedDoctors = this.doctors.slice(startIndex, endIndex);
  // }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.updatePagination();
    }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.updatePagination();
    }
  }


   // Updates pagination for displaying current page's doctors
   updatePagination() {
    const startIndex = this.pageIndex * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.paginatedDoctors = this.doctors.slice(startIndex, endIndex);
  }

  // Handles pagination events
  handlePageEvent(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex;
    this.updatePagination();
  }

  
  constructor(private apiService: ApiService, private router: Router,
     private storage: StorageService, private spinner: NgxSpinnerService, private snackBar: MatSnackBar, private route: ActivatedRoute) {
  }

  // Function for navigating to booking component
  bookNow(doctor: any) {
    this.router.navigate(['/booking', doctor.id]).then(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to top
    });
  }

  // Function for getting doctors according to search params
  getDoctorsList(parameter: any) {
    // showing spinner
    this.spinner.show();
    // Api call for getting doctors according to params
    this.apiService.getBranchDoctorsList(parameter).subscribe({
      next: (response: any) => {
        if (response.success === true) {
          this.apiService.doctors.next(response["data"]); 
          this.doctors = response.data.data;
          this.length = this.doctors.length;
          this.updatePagination();
          // hiding spinner
          this.spinner.hide();
        }else {
          this.snackBar.open(response.message, '', {
            duration: 2000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: 'text-center'
          });
          // hiding spinner
          this.spinner.hide();
        }
      },
      error: (err: any) => {
        // hiding spinner
        this.spinner.hide();
        this.isLoading = false; 
        this.snackBar.open(err.message, '', {
          duration: 2000,
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: 'text-center'
        });
      },
      complete: () => {
        // hiding spinner
        this.spinner.hide();
        this.isLoading = false; 
      }
    });
  }

  ngOnInit(): void {    
    this.isHospitalApp = environment.isHospitalApp; 
    this.hospitalId = environment.hospitalId; 
    this.route.params.subscribe(params => {
      this.branchId = params['branchId'] || null;
      this.specialityId = params['specialtyId'] || null;
    });
    if(this.branchId){
      // Params for getting doctors according to branch id
      this.params =  {
        'branchId': this.branchId,
        ...(this.specialityId ? { specialtyId: this.specialityId } : {})
      }
      this.getDoctorsList(this.params);
    }else if(this.specialityId) {
      // Params for getting doctors according to speciality id
      this.params =  {
        'specialtyId': this.specialityId,
      }
      this.getDoctorsList(this.params);
    }
    else{
      this.params =  {
        'hospitalId': this.hospitalId,
      }
      this.getDoctorsList(this.params);
    }
  }

}
